import classNames from 'classnames';
import { graphql } from 'gatsby';
import React, { useEffect, useRef, useState, MouseEvent } from 'react';
import Flickity from 'react-flickity-component';
import './gallery.scss';
import Image from 'blocks/image/image';
import ModalImage from 'components/modal/modalImage';
import { ImgProps } from 'components/img/img';

interface Props {
  gallery: ImgProps[];
  // images: {
  //   caption?: string;
  //   url: string;
  //   alt: string;
  // }[];
  align?: string;
}

const Gallery: React.FC<Props> = (props) => {
  const sliderRef = useRef<any | null>(null);
  const [sliderIndex, setSliderIndex] = useState<number>(0);

  const [modalOpen, setModalOpen] = useState<boolean>(false);

  const flickityOptions = {
    wrapAround: true,
    prevNextButtons: false,
    pageDots: false,
    initialIndex: 0,
    autoPlay: 5000,
    adaptiveHeight: true,
  };

  useEffect(() => {
    const handleSliderChange = (e: any) => {
      setSliderIndex(e);
    };

    const handleSliderClick = (e: any) => {
      setModalOpen(true);
    };

    if (!!sliderRef.current) {
      sliderRef.current.on('change', handleSliderChange);
      sliderRef.current.on('staticClick', handleSliderClick);
    }
    return () => {
      if (!!sliderRef.current) {
        sliderRef.current.off('change', handleSliderChange);
        sliderRef.current.off('staticClick', handleSliderClick);
      }
    };
  }, []);

  const handleDotClick = (e: MouseEvent) => {
    const target = e.currentTarget;
    const index = parseInt(target.getAttribute('data-index') || '');
    !!sliderRef.current && !!sliderRef.current.select(index);
  };

  return (
    <div className={classNames('gallery', { 'is-smaller': props.align === 'center' })}>
      <div className="gallery__wrapper">
        <div className="gallery__inner">
          <Flickity options={flickityOptions} flickityRef={(ref) => (sliderRef.current = ref)} className="gallery-slider">
            {props.gallery.map((item, key: number) => (
              <div className="gallery-item" key={key}>
                <figure className="gallery-item__image">
                  <img src={item.localFile?.publicURL} alt={item.altText} />
                  {/* <figcaption className="gallery-item__caption">{!!item.caption && item.caption}</figcaption> */}
                </figure>
              </div>
            ))}
          </Flickity>
          <ul className="gallery-dotnav">
            {props.gallery.map((item, key) => (
              <li
                className={classNames('gallery-dotnav__item', {
                  'is-active': key === sliderIndex,
                })}
                key={key}
                data-index={key}
                onClick={handleDotClick}
              />
            ))}
          </ul>
        </div>
      </div>
      {!!modalOpen && props.align !== 'center' && (
        <ModalImage onClose={() => setModalOpen(false)} url={props.gallery[sliderIndex].localFile?.publicURL} alt={props.gallery[sliderIndex].altText} />
      )}
    </div>
  );
};

export const query = graphql`
  fragment GalleryBlock on WpAcfGalleryBlock {
    AcfGalleryBlock {
      gallery {
        ...ContentImage
      }
    }
  }
`;

export default Gallery;
